<template>
  <div class="container">
    <NavigationBar/>
  </div>
    <div class="mt-3">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfVTOL0GOjJl3_OvfWYTfyS6wU31Smm8ezWuHggel15etrDJg/viewform?embedded=true" width="100%" height="1000px" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </div>
  <FooterComponent/>
</template>

<style lang="scss" scoped>
.form-container {
  position: relative;
  width: 100%;
  padding-bottom: 125%; /* Adjust based on form height */
  height: 0;
  overflow: hidden;
}

.form-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

</style>
<script setup>
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/Components/FooterComponent.vue";
</script>
